module.exports = __webpack_public_path__ + "static/img/iv_error1@2x.d364291f.png";